import * as types from './types';

// ── Fetch Attachments ───────────────────────────────────────────

export const fetchAttachmentsRequest = (params = {}) => ({
  type: types.FETCH_ATTACHMENTS_REQUEST,
  payload: params,
});

export const fetchAttachmentsSuccess = (data) => ({
  type: types.FETCH_ATTACHMENTS_SUCCESS,
  payload: data,
});

export const fetchAttachmentsFailure = (error) => ({
  type: types.FETCH_ATTACHMENTS_FAILURE,
  payload: error,
});

// ── Create Attachment ───────────────────────────────────────────

export const createAttachmentRequest = (data, callback) => ({
  type: types.CREATE_ATTACHMENT_REQUEST,
  payload: { data, callback },
});

export const createAttachmentSuccess = (data) => ({
  type: types.CREATE_ATTACHMENT_SUCCESS,
  payload: data,
});

export const createAttachmentFailure = (error) => ({
  type: types.CREATE_ATTACHMENT_FAILURE,
  payload: error,
});

// ── Bulk Attach ─────────────────────────────────────────────────

export const bulkAttachRequest = (data, callback) => ({
  type: types.BULK_ATTACH_REQUEST,
  payload: { data, callback },
});

export const bulkAttachSuccess = (data) => ({
  type: types.BULK_ATTACH_SUCCESS,
  payload: data,
});

export const bulkAttachFailure = (error) => ({
  type: types.BULK_ATTACH_FAILURE,
  payload: error,
});

// ── Detach Policy ───────────────────────────────────────────────

export const detachPolicyRequest = (id, callback) => ({
  type: types.DETACH_POLICY_REQUEST,
  payload: { id, callback },
});

export const detachPolicySuccess = (id) => ({
  type: types.DETACH_POLICY_SUCCESS,
  payload: id,
});

export const detachPolicyFailure = (error) => ({
  type: types.DETACH_POLICY_FAILURE,
  payload: error,
});

// ── Update Attachment ───────────────────────────────────────────

export const updateAttachmentRequest = (id, data, callback) => ({
  type: types.UPDATE_ATTACHMENT_REQUEST,
  payload: { id, data, callback },
});

export const updateAttachmentSuccess = (data) => ({
  type: types.UPDATE_ATTACHMENT_SUCCESS,
  payload: data,
});

export const updateAttachmentFailure = (error) => ({
  type: types.UPDATE_ATTACHMENT_FAILURE,
  payload: error,
});

// ── Sync Status ─────────────────────────────────────────────────

export const fetchSyncStatusRequest = (params = {}) => ({
  type: types.FETCH_SYNC_STATUS_REQUEST,
  payload: params,
});

export const fetchSyncStatusSuccess = (data) => ({
  type: types.FETCH_SYNC_STATUS_SUCCESS,
  payload: data,
});

export const fetchSyncStatusFailure = (error) => ({
  type: types.FETCH_SYNC_STATUS_FAILURE,
  payload: error,
});

export const triggerSyncRequest = (orgId, callback) => ({
  type: types.TRIGGER_SYNC_REQUEST,
  payload: { orgId, callback },
});

export const triggerSyncSuccess = (data) => ({
  type: types.TRIGGER_SYNC_SUCCESS,
  payload: data,
});

export const triggerSyncFailure = (error) => ({
  type: types.TRIGGER_SYNC_FAILURE,
  payload: error,
});

// ── Utilities ───────────────────────────────────────────────────

export const clearAttachmentError = () => ({
  type: types.CLEAR_ATTACHMENT_ERROR,
});
